import { render, staticRenderFns } from "./more-benefit.vue?vue&type=template&id=5478f854&scoped=true&"
import script from "./more-benefit.vue?vue&type=script&lang=js&"
export * from "./more-benefit.vue?vue&type=script&lang=js&"
import style0 from "./more-benefit.vue?vue&type=style&index=0&id=5478f854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478f854",
  null
  
)

export default component.exports